import { OccConfig } from '@spartacus/core';

export const productCrossReferenceOccConfig: OccConfig = {
  backend: {
    occ: {
      endpoints: {
        productCrossReference: '/products/cross-reference?code=${code}&searchType=${searchType}',
      },
    } as any,
  },
};
